import React, {useState} from 'react';
import './style.css';

/*

dashboardMetrics Format (list) (int this order)
- colorClass
- name
- count
- percentage

*/

const DashboardMiniTable = ({ dashboardMetrics, visibleMetrics, toggleMetric }) => {
    return (
        <div className="dashboard-mini-table">
            <table>
                <tbody>
                    {dashboardMetrics.map((rowData, index) => (
                        <tr
                            key={index}
                            className={`metric-row ${visibleMetrics.includes(rowData.name) ? "active" : "inactive"}`}
                            onClick={() => toggleMetric(rowData.name)}
                            style={{
                                cursor: "pointer",
                                opacity: visibleMetrics.includes(rowData.name) ? 1 : 0.5,
                            }}
                        >
                            <td>
                                <span
                                    className="color-circle"
                                    style={{
                                        backgroundColor: rowData.colorClass,
                                        opacity: visibleMetrics.includes(rowData.name) ? 1 : 0.3,
                                    }}
                                ></span>
                            </td>
                            <td>{rowData?.name}</td>
                            <td>{rowData?.count}</td>
                            <td>{rowData?.percentage}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export { DashboardMiniTable };
